module.exports = __webpack_public_path__ + "static/netmvc-557bd3029fe8ccc5416f2ccf525e29be.png";